<date-text-field
  [label]="label"
  [ngModel]="value | async"
  (ngModelChange)="changeValue($event)"
  [min]="min"
></date-text-field>
